import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import ShortcutLink from "@common/ShortcutLink";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import TestNavigation from "../nav/TestNavigation";
import axios from "@common/axios";

const StudentTestsWidget = props => {
    const {className} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const [studentTestResults, setStudentTestResults] = useState([]);

    const loadStudentTestResults = () => {
        axios.get('/web/ui/test/openStudentTestAssignments')
            .then(response => {
                setStudentTestResults(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(user !== undefined && user.student) {
            loadStudentTestResults();
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={brandConfig.useStudentAssessmentReactUI ? '/web/ui/view/test/studentTestAssignments' : '/controlCentre/showStudentTests.action'}>
                        <span>Active {brandConfig.testsName}</span>
                    </ShortcutLink>
                </div>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body'}>
                {studentTestResults.length > 0 && brandConfig.disableConcepts &&
                    <TestNavigation grouping={false}/>
                }
                {studentTestResults.length > 0 && !brandConfig.disableConcepts &&
                    <table style={{width: '100%'}} className={'ch-dashboard-list ch-list'}>
                        <tbody>
                        <tr>
                            <th>{brandConfig.testName}</th>
                            <th>Assigned</th>
                            <th>Expiry</th>
                        </tr>
                        {studentTestResults.map((studentTestResult, index) => (
                            <tr key={studentTestResult.testResultId}>
                                <td>
                                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/test/studentTestAssignments'}>
                                        {studentTestResult.testName}
                                    </ShortcutLink>
                                </td>
                                <td>{user.dateFormat.format(studentTestResult.assignedDate)}</td>
                                <td>{user.dateFormat.format(studentTestResult.endDate)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                }
                {studentTestResults.length == 0 &&
                    <div className="ch-list-item-disabled">No active {brandConfig.testsName.toLowerCase()}</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default StudentTestsWidget;